/**
 * Build the avatar initials shown by the shared header actions from a user's
 * first and last name.
 *
 * Takes the first letter of each name, so "Philipp Schmid" → "PS". When only
 * one of the two names is present, falls back to that single initial; when
 * neither is present, returns an empty string.
 */
export function userInitials(firstname: string, lastname: string): string {
  const first = firstname.trim().charAt(0);
  const last = lastname.trim().charAt(0);
  return `${first}${last}`.toUpperCase();
}
